"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jul 09 2018
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * CompetitorsPriority represents single priority settings between competitors. It is bound
 * to settings (which is related to price zone and product category).
 *
 * @author JMe
 * @author JMr
 */


var CompetitorsPriority =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorsPriority, _DomainObject_1$Domai);

  /**
   * Constructs competitors priority settings.
   *
   * @param id the internal id
   * @param title the name of priority settings set by user
   * @param competitors ordered set of competitors ids
   * @param archived true if it is not displayed to user
   */
  function CompetitorsPriority(id, title) {
    var _this;

    var competitors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : immutable_1.List();
    var archived = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, CompetitorsPriority);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorsPriority).call(this));
    _this.id = id;
    _this.title = title;
    _this.competitors = competitors;
    _this.archived = archived;
    return _this;
  }

  return CompetitorsPriority;
}(DomainObject_1.DomainObject);

exports.CompetitorsPriority = CompetitorsPriority; // tslint:disable-next-line:member-ordering

CompetitorsPriority.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorsPriority.name);
  return {
    id: builder.id('id'),
    title: builder.str('title'),
    competitors: builder.listOf(builder.id('competitors')),
    archived: builder.bool('archived')
  };
}();